import { COLORS } from 'helpers/globals'

const addButton = {
    margin: '0 1.25rem 0 0',
    color: COLORS.primary,
    border: 0,
    padding: 0,
    fontSize: '1.3rem',
    '&:hover': {
      color: COLORS.secondary
    }
  }

const leftSideButton = {
    fontSize: '1.4rem',
    fontWeight: 'bold',
    display: 'block',
    color: COLORS.primary,
    padding: '0 0 0 .5rem !important',
    background: 'white',
    borderColor: 'white',
    '&:hover': {
      background: '#8fb7f6',
      borderColor: '#333333',
      border: '1px',
      color: '#333333',
      borderRadius: 2
    },
    '&:disabled, &[disabled]': {
      cursor: 'not-allowed',
      opacity: 0.65,
      '&:hover': {
        background: 'none',
        color: COLORS.primary
      }
    }
  }

export default {
  container: {
    height: 67,
    borderBottom: `1px solid ${COLORS.quaternary}`,
    borderRight: `1px solid ${COLORS.quaternary}`,
    zIndex: 5,
    userSelect: 'none'
  },
  content: {
    padding: 0,
    height: '100%',
    position: 'relative'
  },
  topRow: {
    height: '100%',
    display: 'flex'
  },
  leftSideThings: {
    display: 'flex',
    minWidth: '32rem',
    padding: '.8rem',
    background: 'white'
  },
  logoWrapper: {
    display: 'inline-block',
    margin: '.7rem .8rem 0 0',
    verticalAlign: 3,
    flex: '0 0 168px',
    '& img': { maxHeight: 40 }
  },
  inputAndButtonsWrapper: {
    display: 'inline-block',
    width: '100%'
  },
  projectInputsWrapper: {
    display: 'block',
    paddingTop: '.5rem'
  },
  titleWrapper: {
    display: 'inline-block',
    width: '75%'
  },
  addButton,
  permalinkButton: addButton,
  permalinkIcon: {
    fontSize: '1.5rem',
    marginRight: 3
  },
  cloneButton: addButton,
  cloneIcon: {
    fontSize: '1.5rem',
    marginRight: 3
  },
  rightSideThings: {
    height: '100%',
    display: 'flex',
    flex: '1 1 auto',
    background: '#eeeeee',
    padding: '.8rem'
  },
  leftSideButton,
  allProjectsButton: {
    ...leftSideButton,
    paddingRight: '1rem !important'
  },
  addIcon: {
    marginRight: '.4rem',
    fontSize: '1.4rem'
  },
  listIcon: {
    marginRight: '.4rem',
    fontSize: '1.4rem'
  },
  messagesWrapper: {
    textAlign: 'center',
    float: 'right'
  }
}



// WEBPACK FOOTER //
// ./src/components/TopBar/style.js